import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../state/reducers/global";
import ModalInsert from "../../components/ModalInsert";
import { useNavigate } from "react-router";
import GenericConfirmInsert from "../../components/GenericConfirmInsert";
import { reviewComplete } from "../../../state/reducers/claimDetailsVendor";
import { clearVehicleRegRequest } from "../../../state/reducers/regSearch";
import { setBucketType } from "./../../../state/reducers/toolbar";
import { setActiveConfirmModalOptionsClaims } from "../../../state/reducers/claimDetailsVendor";

const VendorReviewCompleteDecision = ({ claimData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onConfirm = () => {
    dispatch(reviewComplete(claimData, navigate));

    const type = "claims";
    const data = {
      action: "review-complete",
    };

    dispatch(setActiveConfirmModalOptionsClaims(type, data));
    dispatch(setBucketType("all"));
    dispatch(clearVehicleRegRequest());
  };

  const onCancel = () => {
    dispatch(closeModal());
  };

  return (
    <Fragment>
      <ModalInsert>
        <GenericConfirmInsert
          headerText="Are you sure?"
          bodyText="Are you sure you wish to mark the claim as Review Complete?"
          onCancel={onCancel}
          onConfirm={onConfirm}
          closeBtnText={"Cancel"}
          confirmBtnText={"Confirm"}
        />
      </ModalInsert>
    </Fragment>
  );
};

export default VendorReviewCompleteDecision;
